import { render, staticRenderFns } from "./OverlayModal.vue?vue&type=template&id=1ded7d37&"
import script from "./OverlayModal.vue?vue&type=script&lang=js&"
export * from "./OverlayModal.vue?vue&type=script&lang=js&"
import style0 from "./OverlayModal.vue?vue&type=style&index=0&id=1ded7d37&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports